import { getStatusTagColor } from '../../../../../../features/helpers/componentsHelpers'

import { CHIP_COLORS } from '../../../../../../constants/other'

export const getFormattedAdStatusProps = ad => {
  const isDisapproved =
    // effective_status is property on real ad (not internal ad)
    ad?.effective_status === 'disapproved' ||
    // approval_status is property on internal ad
    ad?.approval_status === 'disapproved'

  const isPendingApproval = ad.internal && ad.approval_status === 'pending_approval'

  if (isDisapproved) {
    return {
      status: 'Disapproved',
      color: CHIP_COLORS.error
    }
  }

  if (isPendingApproval) {
    return {
      status: 'In Review',
      color: CHIP_COLORS.neutral
    }
  }

  return {
    status: ad?.status,
    color: getStatusTagColor(ad?.status)
  }
}
